import { KYBStatusEnum, RightEnum } from "@finway-group/shared/lib/models"
import { Alert } from "antd"
import React from "react"
import { Trans, useTranslation } from "react-i18next"
import { useKYBData } from "~Shared/hooks/corporate.hooks"
import { AuthzService } from "~Shared/services"
import { type Beneficiary } from "~Shared/store/reducers/corporateReducer"
import { getBeneficiariesWithOngoingKybStatusInitiated } from "~Shared/utils/corporate.utils"
import { formatOptionalDate } from "~Shared/utils/date.utils"

export const BeneficiaryStatus = () => {
    const { t } = useTranslation()
    const { beneficiaries } = useKYBData()

    const beneficiariesWithOngoingKybStatusInitiated = getBeneficiariesWithOngoingKybStatusInitiated(beneficiaries)

    const showAlertBasedOnBeneficiaryStatus = ({ status, firstName, lastName, documentExpiryDate, identityRestrictionDate, _id }: Beneficiary) => {
        switch (status) {
            case KYBStatusEnum.APPROVED:
                return (
                    <Alert
                        key={_id}
                        message={t("info:beneficiary.document_expired_warning.title")}
                        description={
                            <Trans
                                t={t}
                                i18nKey="info:beneficiary.document_expired_warning.message"
                                components={[
                                    <a key="1" href={t("info:beneficiary.document_expired_warning.link")} target="_blank" rel="noreferrer" className="text-blue underline" />,
                                ]}
                                values={{
                                    firstName,
                                    lastName,
                                    identityRestrictionDate: formatOptionalDate(identityRestrictionDate),
                                    documentExpiryDate: formatOptionalDate(documentExpiryDate),
                                }}
                            />
                        }
                        type="warning"
                        showIcon={true}
                    />
                )
            case KYBStatusEnum.INITIATED:
                return (
                    <Alert
                        key={_id}
                        message={t("info:beneficiary.account_restricted.title")}
                        description={
                            <Trans
                                t={t}
                                i18nKey="info:beneficiary.account_restricted.message"
                                components={[<a key="1" href={t("info:beneficiary.account_restricted.link")} target="_blank" rel="noreferrer" className="text-blue underline" />]}
                                values={{
                                    firstName,
                                    lastName,
                                }}
                            />
                        }
                        type="warning"
                        showIcon={true}
                    />
                )
            default:
                return null
        }
    }

    if (!AuthzService.isRightGrantedForLoggedInUser(RightEnum.CARD__ALL__WRITE)) {
        return null
    }

    if (!beneficiariesWithOngoingKybStatusInitiated?.length) {
        return null
    }

    return <>{beneficiariesWithOngoingKybStatusInitiated.map((beneficiary) => showAlertBasedOnBeneficiaryStatus(beneficiary))}</>
}
